/* LANJINGMFG V1.18 mobile collection filter state guard */
(() => {
  const selector = '#main-collection-filters details.mobile-facets__disclosure';

  const resetClosedDrawer = (details) => {
    if (!(details instanceof HTMLDetailsElement)) return;
    if (!details.open) details.classList.remove('menu-opening');
  };

  const closeAllMobileFacetDrawers = () => {
    document.querySelectorAll(selector).forEach((details) => {
      details.open = false;
      details.classList.remove('menu-opening');
    });
    document.documentElement.classList.remove('overflow-hidden-mobile');
    document.body?.classList.remove('overflow-hidden-mobile');
  };

  const normalize = () => {
    document.querySelectorAll(selector).forEach(resetClosedDrawer);
  };

  document.addEventListener('DOMContentLoaded', closeAllMobileFacetDrawers, { once: true });
  window.addEventListener('pageshow', closeAllMobileFacetDrawers);
  document.addEventListener('shopify:section:load', closeAllMobileFacetDrawers);

  const mobileMedia = window.matchMedia('(max-width: 749px)');
  mobileMedia.addEventListener?.('change', closeAllMobileFacetDrawers);

  /* Faceted navigation replaces collection HTML with AJAX. Normalize any
     newly inserted drawer state without interfering with a user-open drawer. */
  const observer = new MutationObserver(normalize);
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
